import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box,
    Text,
    Stack,
    Flex,
    Badge,
    Divider,
    SimpleGrid,
    Button,
    ModalFooter,
    useColorModeValue,
} from '@chakra-ui/react'

const UpsellModal = ({ open, handleClose, upsellDetails = [], upsellAmount }) => {
    const cardBg      = useColorModeValue('gray.50', 'whiteAlpha.50')
    const borderColor = useColorModeValue('gray.200', 'whiteAlpha.300')

    return (
        <Modal isOpen={open} onClose={handleClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Upsell details</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    {upsellDetails.length === 0 ? (
                        <Text>No upsells for this order.</Text>
                    ) : (
                        <Stack spacing={4}>
                            {upsellDetails.map((item, idx) => (
                                <Box
                                    key={idx}
                                    p={4}
                                    bg={cardBg}
                                    borderWidth="1px"
                                    borderColor={borderColor}
                                    borderRadius="md"
                                >
                                    <Flex justify="space-between" align="center">
                                        <Text fontWeight="semibold">{item.name}</Text>
                                    </Flex>
                                </Box>
                            ))}

                            <Divider />
                            <Flex justify="space-between" fontWeight="bold">
                                <Text>Total</Text>
                                <Text>{upsellAmount} RON</Text>
                            </Flex>
                        </Stack>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button onClick={handleClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default UpsellModal
